// extracted by mini-css-extract-plugin
export default {"ErrorLogo":"Error_ErrorLogo__2tWrb","ErrorMessage":"Error_ErrorMessage__54IQx"};